export const featuredProperties = [
  {
    id: 4,
    name: "Modern Mountain Stream Overlook",
    tagline: "A beautifully designed mountain cabin with upscale finishes",
    type: "Luxury Mountain Cabin",
    bedrooms: 3,
    bathrooms: 2,
    guests: 6,
    petFriendly: false,
    nearWaterfall: false,
    features: ["Covered Rocking Porch", "Stone Garden Path", "Wooded Setting", "Dormer Windows", "Lush Hydrangea Grounds", "Private Driveway"],
    description: "A beautifully designed cabin in Highlands offering a peaceful mountain setting with upscale finishes. Ideal for a relaxing getaway while still being just a short drive from town and nearby trails.",
    image: "https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/c7d70d81f36a1ecc07e1889c6f4deb01.jpeg",
    location: "Highlands, NC — Forest Setting",
    airbnbUrl: "https://www.airbnb.com/rooms/1309751339447568824",
  },
  {
    id: 3,
    name: "Lark Lodge",
    tagline: "Stylish and inviting retreat in the heart of Highlands",
    type: "Character Cabin",
    bedrooms: 3,
    bathrooms: 2,
    guests: 6,
    petFriendly: true,
    nearWaterfall: false,
    features: ["Covered Front Porch", "Porch Swing", "Stone Fireplace", "Screened Side Porch", "Wooded Setting", "Pet Friendly"],
    description: "A stylish and inviting retreat in Highlands featuring comfortable interiors and a serene natural setting. Perfect for guests looking to unwind while staying close to the area's shops and restaurants.",
    image: "https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/aaecc6fc9d1d9ac8bd4441230fe5683d.jpeg",
    location: "Highlands, NC",
    airbnbUrl: "https://www.airbnb.com/rooms/1617475116852690845",
  },
  {
    id: 2,
    name: "Acorn Cabin — Close to Town",
    tagline: "Classic Highlands character, steps from everything",
    type: "Charming Mountain Cabin",
    bedrooms: 2,
    bathrooms: 2,
    guests: 4,
    petFriendly: false,
    nearWaterfall: false,
    features: ["Close to Downtown Highlands", "Stone Fireplace", "Covered Deck", "Wooded Setting", "Cozy Interior", "Mountain Character"],
    description: "A charming mountain cabin surrounded by nature, offering a cozy and comfortable stay in Highlands. A great choice for a quiet escape with convenient access to local attractions.",
    image: "https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/c817d8b9e474cdd8fa639e63b7ab93d0.jpeg",
    location: "Highlands, NC — Close to Town",
    airbnbUrl: "https://www.airbnb.com/rooms/50702814",
  },
  {
    id: 1,
    name: "Stag Ridge — Luxury Highlands Escape",
    tagline: "A wooded retreat built for comfort and calm",
    type: "Luxury Forest Cabin",
    bedrooms: 4,
    bathrooms: 3,
    guests: 6,
    petFriendly: true,
    nearWaterfall: false,
    features: ["Indoor Stone Fireplace", "Wraparound Deck", "Wooded Setting", "Full Kitchen & BBQ Grill", "Pet Friendly", "Free Parking"],
    description: "A thoughtfully designed cottage blending comfort and simplicity, set in a tranquil Highlands setting. Ideal for enjoying the natural beauty of the area while remaining close to town.",
    image: "https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/46fa8df15f4549c7bb8d2bc9e3c35336.jpeg",
    location: "Highlands, NC — Wooded Ridge",
    airbnbUrl: "https://www.airbnb.com/rooms/1180227781183226897",
  },
];

export const petFriendlyProperties = featuredProperties.filter(p => p.petFriendly);
export const waterfallProperties = featuredProperties.filter(p => p.nearWaterfall);

export const glenfallsCabin = {
  id: 0,
  name: "Glen Falls Luxury Cabin",
  tagline: "Editor\'s top pick — authentic Highlands experience",
  type: "Luxury Cabin",
  bedrooms: 3,
  bathrooms: 2,
  guests: 6,
  petFriendly: true,
  nearWaterfall: true,
  features: ["Pet Friendly", "Near Glen Falls", "Outdoor Wood-Burning Fireplace", "Peaceful Setting", "Close to Downtown Highlands"],
  description: "Glen Falls Luxury Cabin offers a unique blend of privacy, comfort, and location — just minutes from one of Highlands\' most beautiful waterfalls. Thoughtfully designed and surrounded by nature, it provides a peaceful retreat while still being close to town.\n\nWith a consistent 5.0-star rating and recognition as an Airbnb Guest Favorite, it stands among the top homes in the area for guests seeking a refined and relaxing Highlands experience.",
  image: "https://static.readdy.ai/image/ad5520ee7149a263b01f4e3410f2d685/ba0d51886e955561a1eff3aa82f68703.jpeg",
  location: "Highlands, NC — Near Glen Falls",
  airbnbUrl: "https://www.airbnb.com/rooms/900012473285450950",
};
